import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
    SubscriptionData,
    TradingLevelData,
    UsernameAndPhoneData,
} from '../types/onboarding-data';
import type { OnboardingSchema } from '../types/onboarding.schema';

const initialState: OnboardingSchema = {
    currentStepIndex: 0,
    username: '',
    phone: '',
    trading_level: '',
    selectedFeatures: [],
    interval: 'month',
    onboarding_steps_done: [],
    isProcessing: false,
};

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        setCurrentStepIndex: (state, action: PayloadAction<number>) => {
            state.currentStepIndex = action.payload;
        },
        setUsernameAndPhone: (
            state,
            action: PayloadAction<UsernameAndPhoneData>,
        ) => {
            state.username = action.payload.username;
            state.phone = action.payload.phone;
        },
        setTradingLevel: (state, action: PayloadAction<TradingLevelData>) => {
            state.trading_level = action.payload.trading_level;
        },
        setSelectedFeatures: (
            state,
            action: PayloadAction<SubscriptionData>,
        ) => {
            state.selectedFeatures = action.payload.selectedFeatures;
        },
        setInterval: (state, action: PayloadAction<'month' | 'year'>) => {
            state.interval = action.payload;
        },
        setIsProcessing: (state, action: PayloadAction<boolean>) => {
            state.isProcessing = action.payload;
        },
        markStepAsCompleted: (state, action: PayloadAction<string>) => {
            const stepSlug = action.payload;

            if (!state.onboarding_steps_done.includes(stepSlug)) {
                state.onboarding_steps_done = [
                    ...state.onboarding_steps_done,
                    stepSlug,
                ];
            }
        },
        resetOnboarding: () => initialState,
    },
});

export const {
    setCurrentStepIndex,
    setUsernameAndPhone,
    setTradingLevel,
    setSelectedFeatures,
    setInterval,
    setIsProcessing,
    markStepAsCompleted,
} = onboardingSlice.actions;

export const { reducer: onboardingReducer } = onboardingSlice;
